var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 2.33317C3.11248 2.33317 2.90052 2.42097 2.74424 2.57725C2.58796 2.73353 2.50016 2.94549 2.50016 3.1665V14.8332C2.50016 15.0542 2.58796 15.2661 2.74424 15.4224C2.90052 15.5787 3.11248 15.6665 3.3335 15.6665H16.6668C16.8878 15.6665 17.0998 15.5787 17.2561 15.4224C17.4124 15.2661 17.5002 15.0542 17.5002 14.8332V5.6665C17.5002 5.44549 17.4124 5.23353 17.2561 5.07725C17.0998 4.92097 16.8878 4.83317 16.6668 4.83317H9.16683C8.8882 4.83317 8.62801 4.69392 8.47345 4.46209L7.05418 2.33317H3.3335ZM1.56573 1.39874C2.03457 0.929896 2.67045 0.666504 3.3335 0.666504H7.50016C7.77879 0.666504 8.03898 0.805755 8.19354 1.03759L9.61281 3.1665H16.6668C17.3299 3.1665 17.9658 3.4299 18.4346 3.89874C18.9034 4.36758 19.1668 5.00346 19.1668 5.6665V14.8332C19.1668 15.4962 18.9034 16.1321 18.4346 16.6009C17.9658 17.0698 17.3299 17.3332 16.6668 17.3332H3.3335C2.67045 17.3332 2.03457 17.0698 1.56573 16.6009C1.09689 16.1321 0.833496 15.4962 0.833496 14.8332V3.1665C0.833496 2.50346 1.09689 1.86758 1.56573 1.39874Z",
    fill: "#252B30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFolder);
export default __webpack_public_path__ + "static/media/small-folder.a7e6ee86cb15614871095afa5d8959ef.svg";
export { ForwardRef as ReactComponent };